import Model from 'src/storage/base';

class SettingPaymentDetailModel extends Model {
  id = 'SettingPaymentDetailModel';
  defaultState = () => ({
    loading: false,
    changed: false,
    name: '',
    address: '',
    countryAddress: '',
    stateAddress: '',
    cityAddress: '',
    zipcode: '',
    bankName: '',
    bankCountryAddress: '',
    bankStateAddress: '',
    bankCityAddress: '',
    bankAddress: '',
    revolutId: '',
    iban: '',
    swift: ''
  });
  persistent = false;
  apiConfig = {
    update: {
      url: 'profile/update/payment',
      validation: {
        name: 'name',
        countryAddress: ['required', 'countryAddress'],
        cityAddress: 'cityAddress',
        stateAddress: 'stateAddress',
        address: ['required', 'address'],
        zipcode: 'zipcode',
        bankName: 'bankName',
        bankCountryAddress: 'bankCountryAddress',
        bankStateAddress: 'bankStateAddress',
        bankCityAddress: 'bankCityAddress',
        bankAddress: 'address',
        revolutId: 'revolutId',
        iban: 'iban',
        swift: 'swift'
      },
      cancellable: true
    },
    iban: {
      url: 'iban/validate',
      validation: {
        iban: 'iban'
      }
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onHandleChangeProfile = (profile) => {
    this.setState({ ...profile.paymentDetails });
  };

  reset = () => {
    let user = this.state.user;
    this.resetApiState('update');

    this.setState({
      ...this.defaultState(),
      ...user.paymentDetails
    });
  };

  save = () => {
    let req = {
      name: this.state.name,
      address: this.state.address,
      countryAddress: this.state.countryAddress,
      stateAddress: this.state.stateAddress || '',
      cityAddress: this.state.cityAddress || '',
      zipcode: this.state.zipcode,
      bankName: this.state.bankName,
      bankCountryAddress: this.state.bankCountryAddress,
      bankStateAddress: this.state.bankStateAddress,
      bankCityAddress: this.state.bankCityAddress,
      bankAddress: this.state.bankAddress,
      iban: this.state.iban?.toString().split(' ').join(''),
      revolutId: this.state.revolutId,
      swift: this.state.swift
    };

    this.api('update', req, (error, data, success) => {
      if (success) {
        this.reset();
      }
    });
  };

  ibanApi = (iban) => {
    this.api('iban', { iban: iban?.toString().split(' ').join('') }, (error, data) => {
      if (!error) this.setState({ ...data });
    });
  };
}

const model = new SettingPaymentDetailModel();
export default model;
